export const NOO_REGISTRATION_STATUS_TOKEN_STORAGE_KEY =
  'noo_registration_status_token';

export const NOO_REGISTRATION_STATUS_ACCESS_REVOKED_KEY =
  'noo_registration_status_access_revoked';

export function saveNooRegistrationStatusToken(token: string): void {
  if (typeof window === 'undefined' || !token.trim()) {
    return;
  }

  sessionStorage.removeItem(NOO_REGISTRATION_STATUS_ACCESS_REVOKED_KEY);
  sessionStorage.setItem(
    NOO_REGISTRATION_STATUS_TOKEN_STORAGE_KEY,
    token.trim()
  );
}

export function readNooRegistrationStatusToken(): string {
  if (typeof window === 'undefined') {
    return '';
  }

  if (sessionStorage.getItem(NOO_REGISTRATION_STATUS_ACCESS_REVOKED_KEY)) {
    return '';
  }

  return (
    sessionStorage.getItem(NOO_REGISTRATION_STATUS_TOKEN_STORAGE_KEY)?.trim() ??
    ''
  );
}

export function isNooRegistrationStatusAccessRevoked(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  return (
    sessionStorage.getItem(NOO_REGISTRATION_STATUS_ACCESS_REVOKED_KEY) !== null
  );
}

export function clearNooRegistrationStatusToken(): void {
  if (typeof window === 'undefined') {
    return;
  }

  sessionStorage.removeItem(NOO_REGISTRATION_STATUS_TOKEN_STORAGE_KEY);
  sessionStorage.setItem(NOO_REGISTRATION_STATUS_ACCESS_REVOKED_KEY, '1');
}
